<template>
	<div style="padding:5px;background:var(--grey-2);margin-top:5px;">
		<b style="padding-left:0px;color:var(--grey-6);">{{ this.label }}</b> 
		<div style="max-height:150px;overflow:scroll;margin-top:10px;">

			<div style="">
				<SearchMcRow v-for="(mc, index) in this.mcList" :brandId="mc.brandId" :mcId="mc.mcId"
					:key="mc.mcId + '_' + index" @searchMcSelected="((mc) => { this.$emit('searchMcSelected', mc) } )" />
			</div>
		</div>
	</div>
</template>
<script>
import listHelper from '@/helper/list-helper';
import { STORE_GETTER } from '@/store/store';
import SearchMcRow from './SearchMcRow.vue';
import { routerMixin } from "@/mixins/routerMixin.js";

//import SelectManufactor from '@/components/product/search/SelectManufactor.vue';
//import { STORE_GETTER } from '@/store/store';

export default {
	name: "SearchMcView",
	components: { SearchMcRow },
	mixins: [routerMixin],
	data() {
		return {
			baseMcList: []
		};
	},
	computed: {

		mcList() {

				if (this.searchProductConfig && this.searchProductConfig.searchPhrase && this.searchProductConfig.searchPhrase.length > 1) {

					return listHelper.filterList(this.baseMcList, this.searchProductConfig.searchPhrase);

				} 

			return this.baseMcList


		},
		searchProductConfig() {

			return this.$store.getters[STORE_GETTER.SEARCH_PRODUCT_CONFIG];
		},

		baseModelMcTree(){

			const baseModel = this.$store.getters[STORE_GETTER.BASE_MODEL];

			if (baseModel && baseModel.mcTree){
				return baseModel.mcTree;
			}

			return null;

		},

		label() {

			if (!this.mcList || this.mcList?.length == 0){
				return "Hittade inga MC"
			}

			if (this.isOnProductListPage()) {
				return "Filtrera resultat på MC"
			} else {
				return "Visa allt till modell"
			}
		}


	

	},
	watch: {
		baseModelMcTree: function (filter) {
			console.log("FP: watcher: ", filter);
			this.createMcList();
		}
	},
		//filterInput: function (filter) {
		//	console.log("FP: watcher: ", filter);
		//}
	
	methods: {

	
		// this.$store.commit(STORE_COMMIT.SET_PAGE_MENU_OPEN, false);

		// this.$store.dispatch({ type: PRODUCT_STORE_ACTION.TEST_GET_PRODUCT_LIST, data: {} });
		createMcList(){

			// koppla denna till en watch om listan inte är skapad. 

			const baseModel = this.$store.getters[STORE_GETTER.BASE_MODEL];

			if (!baseModel || !baseModel.mcTree){
				return;
			}

			var mcList = [];

			baseModel.mcTree.forEach(brand => {

				

				mcList = mcList.concat(brand.modelList);
				
			});

			this.baseMcList = mcList;
			
		}

	},
	created() {
		// skapa mcList
		this.createMcList();
	}
};
</script>

<style scoped></style>